var $accountAdresseForm = $(".js-account_adresse_form");

$(function(){
    isSubmitAdress = false;

    if($accountAdresseForm.find(".js-submit").val() == 1){
        formMsgBlockShowHide($accountAdresseForm.find(".js-form_successblock"), 5000);
    }

    $accountAdresseForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

        if(isSubmitAdress && typeof isSubmitAdress != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitAdress = true;

        var validSubmit = true;
        var errorCount = 0;

        $.each($accountAdresseForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $accountAdresseForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();
            requestData = "";
            if(typeof $accountAdresseForm[0] != "undefined"){
                $accountAdresseForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST"
            }).done(function(errors){
                $currentButton.removeClass("button_disabled")
                isSubmitAdress = false;

                if(errors == ""){
                    $accountAdresseForm.trigger('submit');
                }else{
                    var errorCount = 0;
                    errors = JSON.parse(errors);

                    $.each(errors, function(key, value){
                        var $field = $("[name=" + value + "]");
                        var $label = $field.siblings(".js-form_label");

                        // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                        var label_text = $field.attr("label_text");
                        if(typeof label_text == 'undefined' || label_text.length == 0) label_text = $field.attr("placeholder");

                        $label.addClass("form_label_text-error");
                        $label.text(label_text + " - " + $field.attr("title"));
                        errorCount++;
                    });
                    formMsgBlockShow($accountAdresseForm.find(".js-form_errorblock"));
                }

                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitAdress = false;
            formMsgBlockShow($accountAdresseForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});